export default __webpack_public_path__ + "static/media/s2.4a651553.jpeg";